import React from 'react';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';

function AppHomePage({ t }) {
  return (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '24px',
    }}
    >
      {t('Wellcome')}
    </div>
  );
}

AppHomePage.propTypes = {};

export default translate(observer(AppHomePage));
